module.exports = __webpack_public_path__ + "img/Support-skill-200.c713b1d1.png";